var React = require('react');

function Checkmark (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","stroke":"#000","strokeWidth":"2","d":"m2 14 7 6L22 4"}));
}

Checkmark.defaultProps = {"aria-label":"Checkmark","viewBox":"0 0 24 24","className":"StyledIcon-sc-ofa7kd-0 iJxtUR"};

module.exports = Checkmark;

Checkmark.default = Checkmark;
